export default {
  VERSION: 1,
  COLLECT: 'https://www.google-analytics.com/collect',
  BATCH: 'https://www.google-analytics.com/batch',
  BATCH_COUNT: 10,
  TYPE: 'event'
};
